import { combineReducers } from 'redux';

import cancelarSolicitacaoEmissaoPID from './cancelarSolicitacao/reducer';

export default combineReducers({
	cancelarSolicitacaoEmissaoPID,
});
